import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Index from "./pages/Index";
import Services from "./pages/Services";
import ServicePage from "./pages/ServicePage";
import WaterPurification from "./pages/WaterPurification";
import PurificationPage from "./pages/PurificationPage";
import ServiceAreas from "./pages/ServiceAreas";
import CityPage from "./pages/CityPage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Reviews from "./pages/Reviews";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

const AppRoutes = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:serviceSlug" element={<ServicePage />} />
      <Route path="/water-purification" element={<WaterPurification />} />
      <Route path="/water-purification/:serviceSlug" element={<PurificationPage />} />
      <Route path="/service-areas" element={<ServiceAreas />} />
      <Route path="/service-areas/:citySlug" element={<CityPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/reviews" element={<Reviews />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Layout>
);

export default AppRoutes;
